import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as React from "react";
import styled from "styled-components";

const SquareButtonDiv = styled.div`
    background-color: #eee;
    padding: 1rem;
    border-radius: 25px;
    transition: background-color ease 0.3s;
    display: flex;
    height: 90px;
    margin-top: 1rem;

    :hover {
        background-color: #ddd;
        cursor: pointer;
    }
`;

export let SquareButton2 = ({ icon, text, description, ...props }) => {
    return (
        <SquareButtonDiv>
            <div style={{ paddingRight: "1rem" }}>
                <FontAwesomeIcon size="2x" icon={icon}></FontAwesomeIcon>
            </div>
            <div>
                <div>{text}</div>
                <div style={{ fontSize: "0.8rem" }}>{description}</div>
            </div>
        </SquareButtonDiv>
    );
};
